import api from './api';

export const getActivityReports = async () => {
  try {
    const token = localStorage.getItem('token');
    const { data } = await api.get('/api/ActivityReport/GetActivityReports', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Activity Reports response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching activity reports:', error);
    throw error;
  }
};

export const addActivityReport = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = '';

    // Validate and convert file to base64
    if (!data.file) {
      throw new Error('Dosya seçilmesi zorunludur');
    }

    // Validate file size (max 10MB)
    if (data.file.size > 10 * 1024 * 1024) {
      throw new Error('Dosya boyutu 10MB\'dan büyük olamaz');
    }

    fileBase64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data.file);
      reader.onload = () => {
        const result = reader.result;
        if (!result) {
          reject(new Error('Dosya okunamadı'));
          return;
        }
        resolve(result);
      };
      reader.onerror = error => {
        console.error('Dosya okuma hatası:', error);
        reject(new Error('Dosya okuma sırasında bir hata oluştu'));
      };
    });

    // Validate required fields
    if (!data.name) throw new Error('Rapor adı zorunludur');
    if (!data.date) throw new Error('Tarih alanı zorunludur');
    if (!fileBase64) throw new Error('Dosya seçilmesi zorunludur');

    const payload = {
      name: data.name,
      date: data.date || new Date().toISOString(),
      fileBase64: fileBase64
    };

    console.log('Sending activity report payload:', {
      ...payload,
      fileBase64: fileBase64 ? '(base64 data present)' : '(no file)'
    });

    const response = await api.post('/api/ActivityReport/AddActivityReports', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Activity report added successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Network Error - No response received');
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};

export const deleteActivityReport = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post('/api/ActivityReport/DeleteActivityReports', { guid }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error deleting activity report:', error);
    throw error;
  }
};
